import React from 'react';
import {Typography} from '~library/atoms/Typography';
import {FlipControls} from './FlipControls';
import {SizeControl} from './SizeControl';
import {RotateControl} from './RotateControl';

export const TransformSection = ({canvas, processing}) => (
  <div className="uyo-control-section">
    <Typography variant="label2" classNames="uyo-control-section-title" color="pebble">
      TRANSFORM
    </Typography>

    <FlipControls canvas={canvas} processing={processing} />

    <SizeControl canvas={canvas} processing={processing} />

    <RotateControl canvas={canvas} processing={processing} />
  </div>
);
